export default __webpack_public_path__ + "static/send-ticket-success-c3f7c6102f909403ef3fecbac841e8bb.svg";